import { FunctionComponent } from "react";

type ListItemProps = {
  icon?: string;
  last?: boolean;
};

const ListItem: FunctionComponent<ListItemProps> = ({
  icon,
  last,
  children,
}) => {
  return (
    <li className={`flex items-center ${last ? null : "mb-6"}`}>
      {icon ? (
        <img
          src={icon ?? "/image-2.jpg"}
          height={18}
          width={18}
          className="mr-3"
        />
      ) : null}
      <p>{children}</p>
    </li>
  );
};

export default ListItem;
